import React from 'react';

// Shows through the end of the closure day, then disappears on its own.
const CLOSED_ON = new Date(2026, 7, 18); // Tuesday, August 18, 2026
const HIDE_AFTER = new Date(2026, 7, 19);

const ClosureBanner = () => {
    if (new Date() >= HIDE_AFTER) return null;

    const day = CLOSED_ON.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' });

    return (
        <div style={{ backgroundColor: '#fff3cd', color: '#664d03', padding: '10px', textAlign: 'center', fontWeight: 600 }}>
            Our office will be closed {day}. The site remains available, and we'll respond to messages when we reopen the
            following day.
        </div>
    );
};

export default ClosureBanner;
